import { render } from "./Number.vue?vue&type=template&id=ff6eaef6&lang=pug"
import script from "./Number.vue?vue&type=script&lang=ts"
export * from "./Number.vue?vue&type=script&lang=ts"
script.render = render

export default script